
export const wishlist =() =>{

var items = JSON.parse(localStorage.getItem("wishlist_array")) == undefined ?  [] : JSON.parse(localStorage.getItem("wishlist_array"))
        return items   
        
 }

export const iswishlist = (id) =>{
   return localStorage.getItem("wishlist_array") == undefined ? undefined: JSON.parse(localStorage.getItem("wishlist_array")).find((x)=>{return x == id})
}
export const addToWishlist = (id) =>{
   var arr = JSON.parse(localStorage.getItem("wishlist_array")) ==null ? [] : JSON.parse(localStorage.getItem("wishlist_array"))
   
   iswishlist(id) == undefined? arr.push(id) :""
    localStorage.setItem("wishlist_array", JSON.stringify(arr)) 
    
}
export const removeFromWishlist = (id) =>{
    var arr = JSON.parse(localStorage.getItem("wishlist_array")) || []
    iswishlist(id) == undefined?  "":removeItem(id, arr)

    localStorage.setItem("wishlist_array", JSON.stringify(arr))
    
}

export const removeItem = (id, arr)=> {
    const index = arr.indexOf(id);
    if (index > -1) {
      arr.splice(index, 1);
        }
    }

export const totalWishlist = ()=>{
    return localStorage.getItem("wishlist_array") == undefined ? 0 : JSON.parse(localStorage.getItem("wishlist_array")).length
}


// WEBPACK FOOTER //
// ./src/components/wishlist.js